import CircularProgress from '@mui/material/CircularProgress';

type LoadingStateProps = Readonly<{
  message?: string;
  size?: number;
}>;

function LoadingState({ message = '데이터를 불러오는 중입니다.', size = 24 }: LoadingStateProps) {
  return (
    <div className="loading-state" role="status" aria-live="polite">
      <CircularProgress size={size} />
      <span>{message}</span>
    </div>
  );
}

export default LoadingState;
